/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.1.0
 * @since 1.0.1
 */

import { FC } from 'react';

import { TextBlock } from '../../../../../../components/common';
import { FlexMiddleStyled, FlexStyled } from '../../../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../../../components/common/Block/Img';
import { LayoutStyled } from '../../../../../../components/common/Block/Layout';

export interface IWidgetNotification {
    className?: string;
    icon: string;
    onClick?: () => void;
    text: string;
}

const WidgetPersonalAccountNotification: FC<IWidgetNotification> = props => (
    <FlexStyled
        className={`widget-personal-account__notification ${props.className}`}
        onClick={props.onClick}
    >
        <LayoutStyled className="mr-2">
            <ImgStyled className="medium" src={props.icon}/>
        </LayoutStyled>
        <FlexMiddleStyled>
            <TextBlock>
                <div dangerouslySetInnerHTML={({ __html: props.text })}/>
                {props.children}
            </TextBlock>
        </FlexMiddleStyled>
    </FlexStyled>
);

export default WidgetPersonalAccountNotification;
